import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-79">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center px-4" onClick={onClose} data-id="element-80">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-81" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="relative bg-navy-800 border border-navy-700 rounded-2xl p-6 md:p-10 max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-82">
            <div className="flex items-center justify-between mb-6" data-id="element-83">
              <h2 className="text-2xl font-bold text-white" data-id="element-84">{title}</h2>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-navy-700 transition-colors text-lavender-300 hover:text-white" data-id="element-85">
                <XIcon size={20} data-id="element-86" />
              </button>
            </div>
            <div className="text-lavender-200 space-y-4 text-base leading-relaxed" data-id="element-87">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-navy-900 py-8 px-4 border-t border-navy-800" data-id="element-88">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-89">
          <p className="text-lavender-300 text-sm" data-id="element-90">
            &copy; {new Date().getFullYear()} Sueño Profundo. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6 text-sm" data-id="element-91">
            <button onClick={() => setShowPrivacy(true)} className="text-lavender-300 hover:text-amber-500 transition-colors" data-id="element-92">
              Política de Privacidad
            </button>
            <button onClick={() => setShowTerms(true)} className="text-lavender-300 hover:text-amber-500 transition-colors" data-id="element-93">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-94">
        <p data-id="element-95">
          <strong className="text-white" data-id="element-96">Última actualización:</strong> Abril
          2026
        </p>
        <p data-id="element-97">
          En Sueño Profundo, respetamos tu privacidad y nos comprometemos a
          proteger tus datos personales. Esta política describe cómo
          recopilamos, usamos y protegemos tu información.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-98">
          1. Información que recopilamos
        </h3>
        <p data-id="element-99">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos información de tarjetas de crédito en nuestros servidores.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-100">
          2. Uso de la información
        </h3>
        <p data-id="element-101">
          Tu información se utiliza exclusivamente para: procesar tu pedido,
          enviarte el producto digital adquirido y comunicarnos contigo en caso
          de ser necesario respecto a tu compra.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-102">
          3. Protección de datos
        </h3>
        <p data-id="element-103">
          Utilizamos medidas de seguridad estándar de la industria para proteger
          tu información personal. Todas las transacciones se procesan a través
          de plataformas de pago seguras con encriptación SSL.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-104">4. Terceros</h3>
        <p data-id="element-105">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. Esto no incluye a terceros de confianza que nos ayudan a
          operar nuestro sitio web o a procesar pagos, siempre que dichas partes
          acuerden mantener esta información confidencial.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-106">5. Cookies</h3>
        <p data-id="element-107">
          Podemos utilizar cookies para mejorar tu experiencia en nuestro sitio.
          Puedes configurar tu navegador para rechazar cookies, aunque esto
          podría afectar algunas funcionalidades.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-108">
        <p data-id="element-109">
          <strong className="text-white" data-id="element-110">Última actualización:</strong> Abril
          2026
        </p>
        <p data-id="element-111">
          Al adquirir el producto "Sueño Profundo (Sin Pastillas)", aceptas los
          siguientes términos y condiciones.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-112">
          1. Producto digital
        </h3>
        <p data-id="element-113">
          Este es un producto digital en formato PDF. Tras completar el pago,
          recibirás acceso instantáneo para descargar el material. Debido a la
          naturaleza digital del producto, no se aceptan devoluciones una vez
          descargado.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-114">2. Uso personal</h3>
        <p data-id="element-115">
          El contenido adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución o reventa total o
          parcial del material sin autorización expresa.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-116">
          3. Descargo de responsabilidad médica
        </h3>
        <p data-id="element-117">
          El contenido de este producto es informativo y educativo. No sustituye
          el consejo médico profesional. Si tienes condiciones médicas
          diagnosticadas como apnea del sueño u otros trastornos, consulta a tu
          médico antes de implementar cualquier protocolo.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-118">4. Resultados</h3>
        <p data-id="element-119">
          Los resultados pueden variar de persona a persona. Las experiencias
          descritas en el material son ilustrativas y no garantizan resultados
          idénticos para todos los usuarios.
        </p>
        <h3 className="text-lg font-bold text-white pt-2" data-id="element-120">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-121">
          Todo el contenido, incluyendo textos, gráficos y metodologías, está
          protegido por derechos de autor. El uso no autorizado constituye una
          violación de las leyes de propiedad intelectual aplicables.
        </p>
      </Modal>
    </>;
}